<template>
    <div
        class="page_single"
        :class="{ 'active': page.content.isActive === true }"
        :style='{ transform: translation}' 
    >
    <!-- <template v-if="loading">
        <Loading/>
    </template> -->
        <PageData
            :pageIndex="pageIndex"
            :pageId="page.content.id"
        />
        <PageSheet
            :page="page"
            ref="pageSheet"
        />
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import PageData from './PageData.vue';
    import PageSheet from './PageSheet.vue';
    // import Loading from '@/components/Global/Loading.vue';
    import { RepositoryFactory } from '../../../repositories/repositoryFactory';
    const ProjectRepository = RepositoryFactory.get('projects');
    import { qrSvg } from '../../../js/qrCodeSvg';

    export default {
        // data() {
        //     return {
        //         loading: true
        //     }
        // },
        props: ['page', 'pageIndex'],
        computed: {
            ...mapState([
                'currentPageIndex',
                'sessionToken'
            ]),
            ...mapGetters([
                'getProject',
                'getCurrentPage',
                'getPageTransition',
                'getPages',
                'getSessionDetails',
                'getPlaceholders'
            ]),
            translation() {
                return'translateY(-'+this.currentPageIndex*100+'%)';
            }
        },
        methods: {
            elements() {
                const pages = this.getPages;
                let elements = [];
                pages.forEach(page => {
                    const placeholderUserInputs = page.content.elements.filter(element => element.placeholder !== undefined).filter(element => element.placeholder.hasPlaceholder === true);
                    elements = [...elements, ...placeholderUserInputs]
                });

                let placeholders = elements.map(el => ({
                    placeholderObj: el.placeholder,
                    content: el.content,
                    ids: [],
                    hasError: false,
                    errorMessage: null
                }));
                
                placeholders = placeholders.map(placeholder => {
                    const placeholderSystemName = placeholder.placeholderObj.placeholderSystemName;

                    const elementsForPlaceholders = elements.filter(el => el.placeholder.placeholderSystemName === placeholderSystemName);

                    let ids = [];
                    elementsForPlaceholders.forEach(el => ids.push(el.id));
                    
                    return {
                        ...placeholder,
                        ids
                    }
                })

                let uniquePlaceholders = placeholders.filter((el, i, arr) => {
                    return arr.findIndex(obj => obj.placeholderObj.placeholderId === el.placeholderObj.placeholderId) === i
                });

                uniquePlaceholders.map(placeholder => {
                    const newestPlaceholderValues = this.getPlaceholders.find(item => item.id === placeholder.placeholderObj.placeholderId).name;
                    placeholder.placeholderObj.placeholderName = newestPlaceholderValues;
                });

                return uniquePlaceholders;
            }
        },
        watch: {
            getPageTransition: {
                deep: true,
                handler: function() {
                    this.$el.style.transform = 'translateY(-'+this.getPageTransition*100+'%)';
                }
            }
        },
        mounted() {
            // if (this.page.number !== undefined) {
            //     const headers = {
            //         'api-key' : 'session',
            //         'api-sign' : this.sessionToken.token
            //     }
            //     ProjectRepository.getProjectPage(this.getProject.id, this.page.number, headers)
            //         .then(result => {
            //             const hasContent = result.data.data.content === null ? false : true;
            //             const elements = hasContent ? result.data.data.content.elements : [];
            //             elements.forEach(element => {
            //                 if (element.type === "TEXT_ELEMENT") {
            //                     const hasPlaceholder = Object.keys(element).includes('placeholder');
            //                     const placeholder = hasPlaceholder ? element.placeholder : {
            //                         hasPlaceholder: false,
            //                         placeholderId: 'noPlaceholder',
            //                         placeholderSystemName: 'noPlaceholder'
            //                     };

            //                     element = {
            //                         ...element,
            //                         placeholder
            //                     }

            //                     if (this.getSessionDetails.mode === 'user') {
            //                         if (placeholder.placeholderSystemName !== 'noPlaceholder') {
            //                             const placeholderSystemName = element.placeholder.placeholderSystemName;
            //                             const placeholderValue = this.getSessionDetails.placeholderValues[placeholderSystemName].value;
            //                             const content = placeholderValue !== null ? placeholderValue : element.content;

            //                             element = {
            //                                 ...element,
            //                                 content
            //                             }
            //                         }
            //                     }                                
            //                 }

            //                 if (element.type === "PHOTO_CELL_ELEMENT") {
            //                     const hasSvgBoolean = Object.keys(element.maskImg).includes('isFromSvg');

            //                     const maskImg = hasSvgBoolean ? element.maskImg : {
            //                         ...element.maskImg,
            //                         isFromSvg: false
            //                     };

            //                     element = {
            //                         ...element,
            //                         maskImg
            //                     }
            //                 }

            //                 const hasLockedValue = Object.keys(element).includes('isLocked');
            //                 const hasNewTransforms = Object.keys(element).includes('newTransforms');
            //                 const isLocked = hasLockedValue ? element.isLocked : false;
            //                 const newTransforms = hasNewTransforms ? element.newTransforms : false;

            //                 const payload = {
            //                     elData: {
            //                         ...element,
            //                         isActive: false,
            //                         isLocked,
            //                         newTransforms
            //                     },
            //                     fromProject: true
            //                 }

            //                 this.$store.dispatch('ADD_PAGE_ELEMENT', payload).then(() => {
            //                     if (element.type === "QR_CODE_ELEMENT") {
            //                         qrSvg(element.content, element.frontColor, element.backColor, element.width, element.id);
            //                     }
            //                 });
            //             });

            //             this.$store.dispatch('SET_PLACEHOLDER_USER_INPUTS', this.elements());
                        
            //         })
            //         .finally(() => {
            //             this.loading = false;
            //         });
            // }
        },
        components: {
            PageData,
            PageSheet,
            // Loading
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';
    .page_single {
        opacity: 0.3;
        transition: 0.8s cubic-bezier(.02,.73,.51,.95);
        display: flex;
        flex-direction: column;
        // height: 100%;
        position: relative;
        height: 650px;
        top: 20px;
        padding-bottom: 40px;
    }
    // @media (max-width: 1500px) {
    //     .page_single {
    //         height: 550px;
    //     }
    // }
    .page_single.active {
        opacity: 1;
    }
</style>